import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { invoiceTypeArray } from "../../../constant/appConstant";
import FormSectionGrid from "../Form/FormSectionGrid";
import FormSectionHeader from "../Form/FormSectionHeader";
import LabelValue from "./LabelValue";

const InvoiceDetails = ({
  pageText,
  candidateDetails,
  invoiceTypes,
}: {
  pageText: any;
  candidateDetails: any;
  invoiceTypes: any;
}) => {
  return (
    <>
      <FormSectionHeader>
        {pageText?.textMetadata.invoicedetailstext}
      </FormSectionHeader>
      <Typography mt={2.5} fontSize="14px">
        {pageText?.labelsMetadata.invoiceHeadingLabel}
      </Typography>
      <Typography mt={2.5} fontWeight="700">
        {
          invoiceTypes[invoiceTypeArray[candidateDetails?.invoiceType] - 1]
            ?.label
        }
      </Typography>
      <FormSectionGrid>
        {candidateDetails?.invoiceType === "myself" &&
          candidateDetails?.[candidateDetails?.invoiceType]?.taxNumber && (
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.taxNumberForACompanyLabel}
                value={
                  candidateDetails?.[candidateDetails?.invoiceType]?.taxNumber
                }
              />
            </Grid>
          )}
        {candidateDetails?.invoiceType !== "myself" && (
          <>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.taxNumberForACompanyLabel}
                value={
                  candidateDetails?.[candidateDetails?.invoiceType]?.taxNumber
                }
              />
            </Grid>
            {candidateDetails?.invoiceType === "another" && (
              <Grid xs={12} sm={6}>
                <LabelValue
                  label={pageText?.labelsMetadata.invoiceFamilyNameLabel}
                  value={candidateDetails?.another?.givenName}
                />
              </Grid>
            )}
            {candidateDetails?.invoiceType === "company" && (
              <Grid xs={12} sm={6}>
                <LabelValue
                  label={pageText?.validationMessages?.invoiceCompanyName}
                  value={candidateDetails?.company?.companyName}
                />
              </Grid>
            )}
            {candidateDetails?.another?.surname && (
              <Grid xs={12} sm={6}>
                <LabelValue
                  label={pageText?.labelsMetadata.invoiceOtherNameLabel}
                  value={candidateDetails?.another?.surname}
                />
              </Grid>
            )}
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.validationMessages?.invoiceTelephoneNumber}
                value={
                  candidateDetails?.[candidateDetails?.invoiceType]?.phoneNo
                }
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.emailAddressLabel}
                value={candidateDetails?.[candidateDetails?.invoiceType]?.email}
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.countryLabel}
                value={
                  candidateDetails?.[candidateDetails?.invoiceType]?.country
                    .label
                }
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.addressLabel}
                value={
                  candidateDetails?.[candidateDetails?.invoiceType]?.address
                }
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelValue
                label={pageText?.labelsMetadata.cityLabel}
                value={candidateDetails?.[candidateDetails?.invoiceType]?.city}
              />
            </Grid>
            {candidateDetails?.[candidateDetails?.invoiceType]
              ?.addressLine2 && (
              <>
                <Grid xs={12} sm={6}>
                  <LabelValue
                    label={pageText?.labelsMetadata.postcodeLabel}
                    value={
                      candidateDetails?.[candidateDetails?.invoiceType]
                        ?.postCode
                    }
                  />
                </Grid>
                <Grid xs={12} sm={6}>
                  <LabelValue
                    label={pageText?.labelsMetadata.addressLabel2}
                    value={
                      candidateDetails?.[candidateDetails?.invoiceType]
                        ?.addressLine2
                    }
                  />
                </Grid>
              </>
            )}
          </>
        )}
      </FormSectionGrid>
    </>
  );
};

export default InvoiceDetails;
